/**
 * Compact AI-bot illustration for the assessment intro. Same visual
 * vocabulary as the site 404 (chat-bubble body, antenna, eyes, a raised
 * hand) but the pose here is "ready to help" rather than "Jedi wave".
 * Uses --ix-* tokens so it inverts in dark mode without a separate copy.
 */
export default function IntroIllustration() {
  return (
    <div
      className="intro-illustration"
      role="img"
      aria-label="A friendly InnovateX AI bot, ready to walk you through the assessment"
    >
      <svg viewBox="0 0 320 200" xmlns="http://www.w3.org/2000/svg" focusable="false">
        <defs>
          <linearGradient id="introBotBody" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="var(--ix-brand-primary)" stopOpacity="0.20" />
            <stop offset="1" stopColor="var(--ix-brand-text)" stopOpacity="0.14" />
          </linearGradient>
          <linearGradient id="introClipboard" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="var(--ix-bg-card)" />
            <stop offset="1" stopColor="var(--ix-bg-surface)" />
          </linearGradient>
        </defs>

        {/* Floating diamonds — echoes the site's page-shape decoration */}
        <g className="intro-illustration__diamonds" opacity="0.5">
          <rect x="30" y="20" width="14" height="14" rx="2"
                fill="var(--ix-brand-primary)" opacity="0.4"
                transform="rotate(45 37 27)" />
          <rect x="280" y="40" width="10" height="10" rx="2"
                fill="var(--ix-brand-text)" opacity="0.4"
                transform="rotate(45 285 45)" />
          <rect x="270" y="150" width="18" height="18" rx="2"
                fill="var(--ix-brand-primary)" opacity="0.25"
                transform="rotate(45 279 159)" />
          <rect x="40" y="160" width="12" height="12" rx="2"
                fill="var(--ix-brand-text)" opacity="0.35"
                transform="rotate(45 46 166)" />
        </g>

        {/* Antenna */}
        <line x1="160" y1="68" x2="160" y2="44"
              stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
        <circle cx="160" cy="40" r="5" fill="var(--ix-brand-primary)"
                stroke="currentColor" strokeWidth="2" />

        {/* Bot body — chat-bubble */}
        <path
          d="M 92 70
             Q 92 60 102 60
             L 218 60
             Q 228 60 228 70
             L 228 150
             Q 228 160 218 160
             L 130 160
             L 116 178
             L 121 160
             L 102 160
             Q 92 160 92 150 Z"
          fill="url(#introBotBody)"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinejoin="round"
        />

        {/* Eyes — open, friendly */}
        <circle cx="128" cy="100" r="7" fill="currentColor" />
        <circle cx="130" cy="98" r="2" fill="var(--ix-bg-card)" />
        <circle cx="180" cy="100" r="7" fill="currentColor" />
        <circle cx="182" cy="98" r="2" fill="var(--ix-bg-card)" />

        {/* Smile */}
        <path d="M 140 128 Q 160 142 180 128"
              stroke="currentColor" strokeWidth="3" fill="none" strokeLinecap="round" />

        {/* Clipboard the bot is holding on the right — fits the "assessment" idea */}
        <g transform="translate(228 90)">
          <rect x="0" y="0" width="60" height="78" rx="6"
                fill="url(#introClipboard)" stroke="currentColor" strokeWidth="2.5" />
          {/* Clipboard clip */}
          <rect x="20" y="-6" width="20" height="10" rx="2"
                fill="var(--ix-brand-primary)" stroke="currentColor" strokeWidth="2" />
          {/* Checklist rows */}
          <g stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.6">
            <line x1="10" y1="22" x2="46" y2="22" />
            <line x1="10" y1="36" x2="46" y2="36" />
            <line x1="10" y1="50" x2="46" y2="50" />
            <line x1="10" y1="64" x2="36" y2="64" />
          </g>
          {/* Brand-cyan check on first row */}
          <path d="M 8 22 l 4 5 l 8 -9"
                stroke="var(--ix-brand-primary)" strokeWidth="3"
                fill="none" strokeLinecap="round" strokeLinejoin="round" />
        </g>
      </svg>
    </div>
  );
}
